import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "icon": "employees-21b62107-icon-D9SRnq",
  "quote": "employees-21b62107-quote-D9SRnq"
};